export default __webpack_public_path__ + "static/media/speedkino_policy.cc6d111f.png";